import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useBillingGate } from "../../context/BillingGateContext";
import { BILLING_ROUTE, MANAGER_HOME_ROUTE } from "../../routes";
import { isSuperAdmin } from "../../utility/Utils";
import {
  shouldRedirectDisabledBillingRoute,
  shouldRestrictClubToBilling,
} from "./billingAccessPolicy";

export default function BillingProtectedRoute({ children, user }) {
  const { state } = useBillingGate();
  const { pathname } = useLocation();
  const clubId = user?.club?._id;
  const isUserSuperAdmin = isSuperAdmin(user);
  const isBillingRoute =
    pathname === BILLING_ROUTE || pathname.startsWith(`${BILLING_ROUTE}/`);

  if (
    isBillingRoute &&
    shouldRedirectDisabledBillingRoute(state, clubId, isUserSuperAdmin)
  ) {
    return <Navigate to={MANAGER_HOME_ROUTE} replace />;
  }

  if (
    !isBillingRoute &&
    shouldRestrictClubToBilling(state, clubId, isUserSuperAdmin)
  ) {
    return <Navigate to={BILLING_ROUTE} replace />;
  }

  return children;
}
